import { render } from "./legoRadio.vue?vue&type=template&id=301a31ce"
import script from "./legoRadio.vue?vue&type=script&lang=js"
export * from "./legoRadio.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/element/legoRadio/legoRadio.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "301a31ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('301a31ce', __exports__)) {
    api.reload('301a31ce', __exports__)
  }
  
  module.hot.accept("./legoRadio.vue?vue&type=template&id=301a31ce", () => {
    api.rerender('301a31ce', render)
  })

}


export default __exports__